import {
    FETCH_CUSTOMER_PARTNERS
} from '../actions/types';

/**
 * helpers
 */
const getPagination = (p = {}, fallbackPerPage = 30) => ({
    currentPage: parseInt(p.current_page, 10) || 1,
    total: parseInt(p.total, 10) || 0,
    perPage: parseInt(p.per_page, 10) || fallbackPerPage,
});

/**
 * initial state
 */
const INIT_STATE = {
    list: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30,
        },
    },
    statistical: null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        /**
         * Danh sách KH (load mới)
         */
        case FETCH_CUSTOMER_PARTNERS: {
            const payload = action.payload || {};
            return {
                ...state,
                list: {
                    items: payload.data || [],
                    pagination: getPagination(payload, 30),
                },
            };
        }

        default:
            return state;
    }
};
